import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import QuotesPayment from "./quotes/QuotesPayment";

class QuotesFormPayment extends Component {
    constructor(props) {
        super(props);

        this.handleInputChange = this.handleInputChange.bind(this);

        this.state = {
            confirmCheckbox: false,
        }
    }

    handleInputChange(event) {
        // event.preventDefault();
        const target = event.target;
        const value = target.name === 'confirmCheckbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    render() {
        console.log(this.props);
        let sendThisObjectWhenSubmitPayment = {

        };
        return (
            <div className='container pb-5'>
                <div className="row justify-content-center py-4">
                    <div className="col-md-10 justify-content-center">
                        <h2 className="text-center py-5">Thank you for accepting our quotation.</h2>
                        <p>
                            Please note that this price covers only the rubbish shown in the photos/video you
                            supplied and recorded in the `Any extras?` section of the online form you completed. <br/><br/>
                            On the day of collection, we can remove additional rubbish but only if you make the
                            appropriate supplementary payment which we will quote. This applies if there is more
                            waste than we have quoted for, or if there are extra items (e.g. fridge, mattress, TV,
                            unemptied paint tin or car tyre) which were not recorded on the form. <br/><br/>
                            If you have any questions, please give us a call on 0330 2020700.
                        </p>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-md-10">
                        <p>To proceed with payment, please acknowledge the terms by ticking the checkbox below.</p>
                        <div className="alert alert-dark">
                            <input
                                name="confirmCheckbox"
                                id="confirmCheckbox"
                                type="checkbox"
                                checked={this.state.confirmCheckbox}
                                onChange={this.handleInputChange}/>
                            <label htmlFor="confirmCheckbox" className="d-inline pl-2">I acknowledge the above terms and want to pay.</label>
                        </div>
                    </div>
                </div>
                {this.state.confirmCheckbox &&
                <div className="pt-4">
                    {this.props.quote.paid !== 1 && this.props.stripe_key &&
                    <QuotesPayment
                        stripe_key={this.props.stripe_key}
                        quote={this.props.quote}
                    />
                    }

                    {(this.props.quote.paid !== 1) && this.props.paymentError &&
                    <div className="alert alert-danger" role="alert">
                        We couldn't process your payment, please check the card details and try again
                    </div>
                    }

                    {this.props.quote.paid === 1 &&
                    <div className="text-center p-5">
                        <h2>This order is already paid.</h2>
                    </div>
                    }
                </div>
                }
            </div>
        );
    }
}

if (document.getElementById('quotesFormPayment')) {
    const element = document.getElementById('quotesFormPayment');
    ReactDOM.render(<QuotesFormPayment
        stripe_key={element.dataset.stripe_key}
        quote={JSON.parse(element.dataset.quote)}
        cut_off={element.dataset.cut_off}
        paymentError={element.dataset.payment_error}
    />, element);
}

export default QuotesFormPayment;
